import React from "react";
import "./css/main.css";
import First from "../assets/public/Image-1.webp";
import Second from "../assets/public/Image-2.webp";
import Third from "../assets/public/Image-3.webp";
import Fourth from "../assets/public/Image-4.webp";
import Fiveth from "../assets/public/Image-5.webp";

const Main = () => {
  return (
    <div className="main-container">
      <h1 className="title">COMPETITIONS RULEBOOK</h1>
      <div className="image-grid">
        <div>
          <img src={First} alt="asdhf" className="image" />
          <img src={Second} alt="adfas" className="image ext_img" />
        </div>
        <img src={Third} alt="adf" className="image-3" />
        <div>
          <img src={Fourth} alt="asdfas" className="image_n" />
          <img src={Fiveth} alt="asfas" className="image_n ext_img" />
        </div>
      </div>
    </div>
  );
};

export default Main;
